import { Component, OnInit } from '@angular/core';
import { PickupTableComponent } from '../pickup-table/pickup-table.component';
import { PickupTableFilterComponent } from '../pickup-table-filter/pickup-table-filter.component';

@Component({
    selector: 'app-pickup-page',
    templateUrl: './pickup-page.component.html',
    styleUrls: ['./pickup-page.component.scss'],
    imports: [PickupTableFilterComponent, PickupTableComponent]
})
export class PickupPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
